import applicationEventHub from "../../events/applicationEventHub";

export default {
    namespaced: true,
    state: {
        paused : false,
        journey: null,
        frameworkMediacompositions : {}
    },
    mutations: {
        togglePauseOff(state) {
            state.paused = true;
        },
        togglePauseOn(state) {
            state.paused = false;
        },
        setJourney(state,journey){
            state.journey=journey;
            if(!journey){
              state.paused = false;
            }
        },
        setFrameworkMediacompositions(state,comps){
            state.frameworkMediacompositions=comps;
        }
    },
    actions: {
        toggleJourneyPauseState({commit, state}) {
            if(!state.paused) {
                commit('togglePauseOff');
                applicationEventHub.pauseMedia();
            } else {
                commit('togglePauseOn');
                applicationEventHub.playMedia();
            }
        },
        loadForAssessment({commit, dispatch},assessmentid){
            return this.$http.get('/assessments/'+assessmentid+'/journey').then((response)=>{
                const data=response.data.data;
                commit('setJourney',data.journey);
                commit('setFrameworkMediacompositions',data.framework_mediacompositions);
                commit('textassets/addTextassets',data.textassets,{root:true});
                return dispatch('assets/setAssetList',data.assets,{root:true});
            });
        }
    },
    getters: {
        orientation(state){
            if(!state.journey){
                return;
            }
            return state.journey.orientationcontent;
        },
        journeyTotalMinutes(state){
            if(!state.journey){
                return null;
            }
            return state.journey.journeyphases.map((phase)=>phase.time_estimation).reduce((a, b) => a + b, 0);
        }
    }
}
